<template>
  <div class="dispatch-user-role">
    <div class="toolbar">
      <span class="hint">账号：{{ username }}（{{ name }}）</span>
      <a-button type="primary" :loading="saving" @click="save">保存</a-button>
    </div>
    <a-spin :spinning="loading">
      <a-checkbox-group v-model="checkedIds" class="role-list">
        <label v-for="item in roleList" :key="item.id" class="role-item">
          <a-checkbox :value="item.id" :disabled="Number(item.available) !== 1">
            <span class="role-name">{{ item.name }}</span>
            <span v-if="item.description" class="role-desc">{{ item.description }}</span>
          </a-checkbox>
        </label>
      </a-checkbox-group>
      <a-empty v-if="!loading && !roleList.length" description="暂无可用角色" />
    </a-spin>
  </div>
</template>

<script>
import { dispatchApi } from "./dispatchApi";

export default {
  name: "DispatchUserRoleAssign",
  props: {
    userId: {
      type: [Number, String],
      required: true,
    },
    username: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      roleList: [],
      checkedIds: [],
      loading: false,
      saving: false,
    };
  },
  watch: {
    userId: {
      immediate: true,
      handler() {
        this.load();
      },
    },
  },
  methods: {
    async load() {
      if (!this.userId) return;
      this.loading = true;
      try {
        const [roles, assigned] = await Promise.all([
          dispatchApi.listAllRoles(),
          dispatchApi.listUserRoles(this.userId),
        ]);
        this.roleList = roles || [];
        this.checkedIds = (assigned || []).map((r) => r.id);
      } catch (e) {
        this.$message.error((e && e.message) || "加载角色失败");
        this.roleList = [];
        this.checkedIds = [];
      } finally {
        this.loading = false;
      }
    },
    async save() {
      if (!this.checkedIds.length) {
        this.$message.warning("请至少选择一个角色");
        return;
      }
      this.saving = true;
      try {
        await dispatchApi.assignUserRoles(this.userId, this.checkedIds);
        this.$message.success("角色分配成功");
        this.$emit("saved");
      } catch (e) {
        this.$message.error((e && e.message) || "保存失败");
      } finally {
        this.saving = false;
      }
    },
  },
};

</script>

<style scoped>
.dispatch-user-role {
  display: flex;
  flex-direction: column;
  min-height: 280px;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.hint {
  color: #64748b;
  font-size: 13px;
}

.role-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.role-item {
  display: block;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
}

.role-item:hover {
  border-color: #0082d4;
  background: #f8fafc;
}

.role-item >>> .ant-checkbox-wrapper {
  width: 100%;
}

.role-name {
  font-weight: 500;
}

.role-desc {
  display: block;
  margin-left: 24px;
  margin-top: 4px;
  color: #94a3b8;
  font-size: 12px;
}
</style>
